import { FC, useCallback, useMemo, useState } from 'react';
import { Button, Card, Divider, RadixTable, TColumn } from '@features/ui';
import Pagination from '@features/ui/components/pagination.tsx';
import { TExchangePackagesTable } from '@src/types/exchangePackages.ts';
import { CancelIcon } from '@features/ui/icons';
import { CheckIcon } from 'lucide-react';
import { exchangeDataTable } from '@features/admin/packages/packagesData.ts';

interface ExchangePackageTableProps {
  onEdit?: (id: string) => void;
}
export const ExchangePackageTable: FC<ExchangePackageTableProps> = ({
  onEdit,
}) => {
  const [currentPage, setCurrentPage] = useState(1);

  const handleEdit = useCallback(
    (id?: string) => {
      if (!id) return;
      onEdit?.(id);
    },
    [onEdit]
  );

  const columns = useMemo(
    (): TColumn<TExchangePackagesTable>[] => [
      { title: 'Name', render: (item) => <p>{item?.name ?? ''}</p> },
      {
        title: 'Category',
        render: (item) => (
          <div className={'flex gap-x-6'}>
            <p>{item?.category ?? ''}</p>
            <p className={'font-bold'}>{item?.platform ?? ''}</p>
          </div>
        ),
      },
      {
        title: 'Visible on Website',
        render: () => (
          <div className={'flex w-[126px] justify-center'}>
            <CancelIcon />
          </div>
        ),
      },
      {
        title: 'Active MINT Processing',
        render: () => (
          <div className={'flex w-[157px] justify-center'}>
            <div
              className={
                'bg-lime h-4.5 w-4.5 rounded-full flex items-center justify-center'
              }
            >
              <CheckIcon />
            </div>
          </div>
        ),
      },
      {
        title: 'Action',
        render: (item) => (
          <Button
            size={'sm'}
            variant={'secondary'}
            onClick={() => handleEdit(item?.id)}
          >
            Edit
          </Button>
        ),
      },
    ],
    [handleEdit]
  );

  return (
    <Card className={'flex flex-col items-end'}>
      <RadixTable columns={columns} data={exchangeDataTable} />
      <Divider />
      <Pagination
        className={'mt-7'}
        current={currentPage}
        total={2}
        onChange={setCurrentPage}
      />
    </Card>
  );
};
